import React from 'react';

const LoadingMask = ({ loading }) => {
  if (!loading) return null; // Do not render if not loading

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-40 z-10">
      <svg
        className="w-10 h-10 animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-20"
          cx="12"
          cy="12"
          r="10"
          stroke="#000"
          strokeWidth="4"
        />
        <path
          d="M4 12a8 8 0 018-8v8z"
          fill="url(#spinner-gradient)"
        />
        <defs>
          <linearGradient id="spinner-gradient" x1="4" y1="4" x2="20" y2="20" gradientUnits="userSpaceOnUse">
            <stop stopColor="#000" stopOpacity="0.8" />
            <stop offset="1" stopColor="#333" stopOpacity="0.2" />
          </linearGradient>
        </defs>
      </svg>
      <p className="ml-3 text-sm font-medium text-black">Loading...</p>
    </div>
  );
};

export default LoadingMask;
